import type { Locale } from '@/lib/i18n'

interface UnitLabel {
    ar: string
    en: string
    enPlural: string
}

export const UNITS: Record<string, UnitLabel> = {
    piece: { ar: 'قطعة', en: 'piece', enPlural: 'pieces' },
    pack: { ar: 'عبوة', en: 'pack', enPlural: 'packs' },
    set: { ar: 'طقم', en: 'set', enPlural: 'sets' },
    dozen: { ar: 'دستة', en: 'dozen', enPlural: 'dozens' },
    carton: { ar: 'كرتونة', en: 'carton', enPlural: 'cartons' },
    bag: { ar: 'شنطة', en: 'bag', enPlural: 'bags' },
    roll: { ar: 'لفة', en: 'roll', enPlural: 'rolls' },
    kg: { ar: 'كيلو', en: 'kg', enPlural: 'kg' }
}

export const UNIT_KEYS = Object.keys(UNITS)

export const unitLabel = (unit: string, locale: Locale, count = 1): string => {
    const label = UNITS[unit]

    if (!label) return unit

    if (locale === 'en') return count === 1 ? label.en : label.enPlural

    return label.ar
}
